"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _reactComponents = require("@ui-propulsion/react-components");
var _reactHookForm = require("react-hook-form");
require("@ui-propulsion/core/styles.scss");
var _useOffers2 = _interopRequireDefault(require("./hooks/use-offers"));
require("./styles.scss");
var _components = require("./components");
var _util = require("./util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var swap = function swap(arr, i, j) {
  if (i === j) return;
  var tmp = arr[i];

  /* eslint-disable no-param-reassign */
  arr[i] = arr[j];
  arr[j] = tmp;
  /* eslint-enable no-param-reassign */
};
var moveMainPayeeInfront = function moveMainPayeeInfront(list, clientId) {
  if (!list || !list.length) return;
  var index = list.findIndex(function (_ref) {
    var id = _ref.id;
    return id === clientId;
  });
  swap(list, 0, index);
};
var Revisions = function Revisions(_ref2) {
  var header = _ref2.header,
    revisor = _ref2.revisor,
    application = _ref2.application,
    constants = _ref2.constants,
    renderDisclosure = _ref2.renderDisclosure,
    maxPayeeCount = _ref2.maxPayeeCount,
    onSubmit = _ref2.onSubmit;
  var payees = application.applicationPayees,
    productType = application.productType,
    oracleApplicationId = application.oracleApplicationId,
    loanAmount = application.loanAmount,
    clientId = application.clientId;
  var offerURL = revisor.offerURL;
  moveMainPayeeInfront(payees, clientId);
  /*
    `amount` is being controlled by react-hook-form.
    We have to create an extra amount state to trigger the useOffers declaratively.
    We can update this one later on as we learn more about react-query.
    See https://github.com/tannerlinsley/react-query/discussions/442
  */
  var _useState = (0, _react.useState)(+loanAmount),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  var _useOffers = (0, _useOffers2.default)(offerURL, {
      oracleApplicationId: oracleApplicationId,
      amount: amount,
      secondaryPayeeClientId: application.secondaryPayeeClientId
    }),
    _useOffers$data = _useOffers.data,
    offers = _useOffers$data === void 0 ? [] : _useOffers$data;
  var defaultValues = {
    payees: updatePayees(),
    selectedOffer: ''
  };
  var formFields = (0, _reactHookForm.useForm)({
    defaultValues: defaultValues,
    mode: 'onChange'
  });
  var handleSubmit = formFields.handleSubmit,
    getValues = formFields.getValues,
    formState = formFields.formState;
  var bem = (0, _util.bemClass)('revisions');
  return /*#__PURE__*/_react.default.createElement(_reactComponents.App, null, /*#__PURE__*/_react.default.createElement(_components.Header, header), /*#__PURE__*/_react.default.createElement(_components.CurrentPlan, application), /*#__PURE__*/_react.default.createElement(_components.Form, {
    handleSubmit: handleSubmit(onSubmit),
    formState: formState
  }, /*#__PURE__*/_react.default.createElement(_components.Revisor, Object.assign({
    maxPayeeCount: maxPayeeCount,
    offers: offers,
    handleAmountChange: (0, _lodash.default)(function () {
      return setAmount((0, _util.totalAmount)(getValues('payees')));
    }, 1000),
    onPayeeRemove: function onPayeeRemove() {
      setAmount((0, _util.totalAmount)(getValues('payees')));
    }
  }, revisor, formFields, application)), /*#__PURE__*/_react.default.createElement(_components.MainSection, Object.assign({
    offers: offers,
    productType: application.productType,
    constants: constants
  }, formFields))), /*#__PURE__*/_react.default.createElement("footer", {
    className: bem('disclosures-section')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('disclosures-texts')
  }, renderDisclosure(productType))));
  function updatePayees() {
    return (payees === null || payees === void 0 ? void 0 : payees.length) === 1 ? [_objectSpread(_objectSpread({}, payees[0]), {}, {
      payeeAmount: parseInt(application.loanAmount || application.amount || 0, 10)
    })] : payees.map(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        /*
          There is a bug in Propulsion's TextField of type currency
          where it ignores the dot on the supplied value. (i.e. "1000.00" is being shown as "$100,000")
          */
        payeeAmount: parseInt(p.payeeAmount, 10)
      });
    });
  }
};
Revisions.propTypes = {
  header: _propTypes.default.shape({
    displayName: _propTypes.default.string.isRequired,
    buttonText: _propTypes.default.string,
    onCancel: _propTypes.default.func
  }).isRequired,
  revisor: _propTypes.default.shape({
    tooltip: _propTypes.default.string.isRequired,
    offerURL: _propTypes.default.string.isRequired,
    onAddProvider: _propTypes.default.func
  }).isRequired,
  application: _propTypes.default.shape({
    id: _propTypes.default.number,
    clientId: _propTypes.default.number,
    oracleApplicationId: _propTypes.default.number,
    applicationPayees: _propTypes.default.arrayOf(_propTypes.default.object),
    loanAmount: _propTypes.default.string,
    amount: _propTypes.default.string,
    payment: _propTypes.default.string,
    monthlyPayment: _propTypes.default.string,
    productType: _propTypes.default.string,
    introTerm: _propTypes.default.number,
    term: _propTypes.default.number,
    isInterestFree: _propTypes.default.bool,
    intRate: _propTypes.default.string,
    rate: _propTypes.default.string,
    secondaryPayeeClientId: _propTypes.default.number
  }).isRequired,
  constants: _propTypes.default.shape().isRequired,
  renderDisclosure: _propTypes.default.func.isRequired,
  maxPayeeCount: _propTypes.default.number,
  onSubmit: _propTypes.default.func.isRequired
};
Revisions.defaultProps = {
  maxPayeeCount: 1
};
var _default = exports.default = Revisions;
